import React, { useContext, useEffect } from "react";
import { Stepper, Step, StepLabel, createMuiTheme, MuiThemeProvider } from "@material-ui/core";
import { AppContext } from "./Context";
import Cart from "../ShoppingCart";
import AddAddress from "../AddAddress";
import OrderSummary from "../OrderSummary";
import OrderCreatedSuccess from "../OrderSummary/OrderCreatedSuccess";

import { useStyles } from './styles';

// Step titles
const steps = ["Carrito de Compra", "Datos de Envío", "Confirmación"];
const handleSteps = (step: number) => {
    switch (step) {
        case 0:
            return <Cart />;
        case 1:
            return <AddAddress />;
        case 2:
            return <OrderSummary />;
        case 3:
            return <OrderCreatedSuccess />;
        default:
            throw new Error("Unknown step");
    }
};

const muiTheme = createMuiTheme({
    overrides: {
        MuiStepIcon: {
            root: {
            '&$completed': {
                color: 'green',
            },
            '&$active': {
                color: '#f50057',
            },
            },
            active: {},
            completed: {},
        }
    }
});

const OrderFlux = () => {
    const classes = useStyles();
    const { activeStep } = useContext(AppContext);

    useEffect(() => {
        if (activeStep === steps.length) {
            const onbeforeunload = () => {
                localStorage.removeItem('activestep');
            }

            window.addEventListener('beforeunload', onbeforeunload);

            return () => {
                window.removeEventListener('beforeunload', onbeforeunload);
            }
        }
    }, [activeStep]);

    return (
        <MuiThemeProvider theme={muiTheme}>
            <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((step) => (
                    <Step className={classes[".MuiStep-horizontal"]} key={step}>
                        <StepLabel>{step}</StepLabel>
                    </Step>
                ))}
            </Stepper>
            {handleSteps(activeStep)}
        </MuiThemeProvider>
    );
};

export default OrderFlux;

